module.exports = __webpack_public_path__ + "img/facebook.bad04df0.svg";